import { useInfiniteQuery, useAuthStore } from '@northladder/services';

import { BIDS_API } from '../bidsAPIClient';
import {
  IUploadedBidFilesPaginatedData,
  TFetchUploadBidFilesPayload,
} from '../types';

/**
 * This is to track the upload bid files key in react query cache.
 */
export const FETCH_UPLOAD_BID_FILES_KEY = 'fetch-upload-bid-files-key';

export interface IUseAllBidsSuccessCallbackProps {
  pages: IUploadedBidFilesPaginatedData[];
}

/**
 * This performs a get request and retrieves the upload bids files data by
 * category.
 * Provides data fetching states to be used in the upload bid files table.
 *
 * TODO: This needs massive refactoring. Marking it as deprecated to highlight this.
 * @deprecated - Refactor this.
 */
export const useUploadBidFilesQuery = (
  payload: TFetchUploadBidFilesPayload
) => {
  const userId = useAuthStore.getState()?.activeSession?.userId || '';

  const { categoryId, count, page } = payload;

  const {
    data,
    isLoading,
    isPending,
    isError,
    error,
    isPaused,
    refetch,
    hasNextPage,
    fetchNextPage,
    isFetchingNextPage,
  } = useInfiniteQuery({
    // eslint-disable-next-line @tanstack/query/exhaustive-deps
    queryKey: [FETCH_UPLOAD_BID_FILES_KEY, userId, categoryId, count, page],
    enabled: false, // It's a dependant query so don't run immediately.
    networkMode: 'always', // Even make calls when offline
    queryFn: ({ pageParam = 1 }) =>
      BIDS_API.fetchUploadBidFiles({ ...payload, page: pageParam }),
    initialPageParam: 1,
    getNextPageParam: (lastPage, allPages) => {
      if (!lastPage || typeof lastPage.totalCount !== 'number') {
        // If lastPage is null or totalCount is missing, stop pagination
        return undefined;
      }
      const nextPage = allPages.length + 1;
      const currentAssetCount = allPages.length * payload.count;
      return currentAssetCount < lastPage.totalCount ? nextPage : undefined;
    },
  });

  return {
    data,
    error,
    fetchNextPage,
    hasNextPage,
    isError,
    isFetchingNextPage,
    isLoading,
    isPaused,
    isPending,
    refetch,
  };
};
